
<template>
  <section v-html="content" v-once />
</template>
<script>
export default {
  created() {
    this.content = unescape(`%3Ch1%3E%u4ECB%u7ECD%3C/h1%3E%0A%3Cdiv%20class%3D%22card%22%3E%3Ch3%20id%3D%22guan-yu%22%3E%u5173%u4E8E%3C/h3%3E%0A%3Cp%3EBeyond-UI%2C%20%u5FEB%u901F%u4E0A%u624B%u7684%u4E1A%u52A1%u7EC4%u4EF6%u5E93%u3002%3C/p%3E%0A%3C/div%3E%3Cdiv%20class%3D%22card%22%3E%3Ch3%20id%3D%22te-xing%22%3E%u7279%u6027%3C/h3%3E%0A%3Cul%3E%0A%3Cli%3E%u66F4%u7B80%u5355%uFF0C%u5E38%u7528%u4E1A%u52A1%u7EC4%u4EF6%2C%20%u6EE1%u8DB3%u5E38%u89C1%u9875%u9762%u9700%u6C42%u3002%3C/li%3E%0A%3Cli%3E%u66F4%u7075%u6D3B%uFF0C%u7EC4%u4EF6%u4E92%u76F8%u7EC4%u5408%u751F%u6210%u66F4%u591A%u53EF%u80FD%u3002%3C/li%3E%0A%3Cli%3E%u517C%u5BB9%20nuxt%uFF0C%u652F%u6301%20nuxt%20%u670D%u52A1%u7AEF%u6E32%u67D3%u3002%3C/li%3E%0A%3C/ul%3E%0A%3C/div%3E`);
  },
mounted() {
    const anchors = [].slice.call(this.$el.querySelectorAll('h2, h3, h4, h5'));
    anchors.forEach(anchor => {
      anchor.addEventListener('click', this.scrollToAnchor);
    });
  },
  methods: {
    scrollToAnchor(event) {
      if (event.target.id) {
        this.$router.push({
          path: this.$route.path,
          hash: event.target.id
        })
      }
    }
  },

};
</script>
